export enum RouteName {
  appCatalog = 'developer-app-catalog',
}
